<template>
    <div class="authWrapper w-full flex items-center">
        <div class="inner">
            <div class="logoHolder">
                <Logo/>
            </div>
            <Box>
                <slot/>
            </Box>
            <slot name="below"></slot>
        </div>
    </div>
</template>

<script>
import Box from '../ui/Box.vue';
import Logo from '../ui/Logo.vue';

export default {
    components: {
        Box,
        Logo,
    },
};
</script>

<style lang="postcss" scoped>
.inner {
    width: 550px;
    margin: 50px auto;
    margin-bottom: 10vh;
}
.logoHolder {
    width: 200px;
    margin: 0 auto 50px;
}
</style>
